import { Radio, RadioGroup } from "@fluentui/react-components";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";
import { BooleanFilter as BooleanFilterType, Column } from "./types";

type Props = {
  column: Column;
};

export const BooleanFilter = ({ column }: Props) => {
  const filter = column.filter as BooleanFilterType;
  const { setFilter, strings, id } = useContext(ColumnOptionsContext);

  const selectedValue =
    filter.value === true
      ? "true"
      : filter.value === false
      ? "false"
      : undefined;

  return (
    <RadioGroup
      value={selectedValue}
      id={id ? `${id}-booleanFilter-${column.key}` : undefined}
      onChange={(_, data) => {
        const value =
          data.value === "true" ? true : data.value === "false" ? false : null;
        setFilter(column.key, { ...filter, value });
      }}
    >
      <Radio value="true" label={strings.booleanFilterTrueLabel} />
      <Radio value="false" label={strings.booleanFilterFalseLabel} />
    </RadioGroup>
  );
};
